export const createSlug = (title) => {
  if (!title) return "unknown";

  const titleStr = typeof title === 'object'
    ? (title.english || title.romaji || title.native || "unknown")
    : String(title);

  return titleStr
    .toLowerCase()
    .replace(/[^\w\s-]/g, "") // Remove special chars
    .replace(/[\s_-]+/g, "-") // Replace spaces/underscores with dashes
    .replace(/^-+|-+$/g, ""); // Trim dashes from start/end
};
